import { render, staticRenderFns } from "./SwitchesColors.vue?vue&type=template&id=c7bd7784&"
import script from "./SwitchesColors.vue?vue&type=script&lang=js&"
export * from "./SwitchesColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports